import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../_models/user.model';
import { AuthenticationService } from '../services/authentication.service';
import { AppService } from '../services/app.service';
import { escapeLeadingUnderscores } from 'typescript';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  currentUser: User;
    constructor(private authenticationService: AuthenticationService,private appService:AppService) {
        
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // add authorization header with jwt token if available
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
      var utm = this.appService.getUTMTrackingStorage();
      if (this.currentUser) {
        if (utm) {
          request = request.clone({
            setHeaders: {
              'Authorization': 'Bearer ' + this.currentUser.accessToken,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'T2D-UTM': utm
            }
          });
        } else {
          request = request.clone({
            setHeaders: {
              'Authorization': 'Bearer ' + this.currentUser.accessToken,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        }
      }
      else {
        if (utm) {
          request = request.clone({
            setHeaders: {
              'T2D-UTM': utm
            }
          });
        }
      }
      return next.handle(request);
    }
}
